import { RootStateDesktop } from "@desktop/store/configureStore";
import { RootStateMobile } from "@mobile/store/configureStore";
import { createReducer } from "@shared/reducers/utils";

import {
  TOGGLE_BUY_INTERNET_TIME_MODAL,
  TOGGLE_RESPONSE_BUY_INTERNET_TIME_MODAL,
} from "../consts";

type BaseBooleanAction = { type: string; payload: boolean };

const initialState = {
  showBuyInternetTimeModal: false,
  responseBuyInternetTimeModal: {
    isShow: false,
    isError: false,
  },
};

export const sweepstakesReducer = createReducer(initialState, {
  [TOGGLE_BUY_INTERNET_TIME_MODAL](
    state: RootStateDesktop | RootStateMobile,
    action: BaseBooleanAction
  ) {
    return {
      ...state,
      showBuyInternetTimeModal: action.payload,
    };
  },
  [TOGGLE_RESPONSE_BUY_INTERNET_TIME_MODAL](
    state: RootStateDesktop | RootStateMobile,
    action: BaseBooleanAction
  ) {
    return {
      ...state,
      responseBuyInternetTimeModal: action.payload,
    };
  },
});
